export default __webpack_public_path__ + "static/media/8_DanseSmatte.1f078e5a.mp3";